import { j as n } from "./jsx-runtime-C5mzlN2N.js";
import { c as $, L as O, e as M, i as L } from "./chunk-BAXFHI7N-C9WnHsLV.js";
import { UnlinkIcon as w } from "lucide-react";
import { C as F } from "./CategoryHeading-DZi-Szor.js";
import { Callout as k } from "./ui/Callout.js";
import { M as b, H as y, P as v } from "./Markdown-D96AphCL.js";
import A, { memo as D, useContext as H } from "react";
import { e as U } from "./hook-BwOB_iZo.js";
import { h as V } from "./SyntaxHighlight-UxOF1xNb.js";
import { i as z, Z as C } from "./invariant-DAFpPywt.js";
import { CodeBlock as q } from "./ui/CodeBlock.js";
import { c as Z } from "./cn-CwJPJKOE.js";
import { u as W } from "./useExposedProps-DG8J6ewJ.js";
const N = ({
  children: r,
  className: a
}) => {
  if (process.env.NODE_ENV === "development")
    return /* @__PURE__ */ n.jsx(k, { type: "caution", title: "Developer hint", className: a, children: /* @__PURE__ */ n.jsxs("div", { className: "flex flex-col gap-2", children: [
      typeof r == "string" ? /* @__PURE__ */ n.jsx(b, { content: r }) : /* @__PURE__ */ n.jsx("div", { children: r }),
      /* @__PURE__ */ n.jsx("small", { className: "italic", children: "Note: This hint is only shown in development mode." })
    ] }) });
}, j = () => {
  const r = $();
  return /* @__PURE__ */ n.jsxs("div", { className: v + " h-full pt-[--padding-content-top]", children: [
    /* @__PURE__ */ n.jsx(F, { children: "404" }),
    /* @__PURE__ */ n.jsxs(y, { level: 1, className: "flex gap-3.5 items-center", children: [
      "Page not found",
      /* @__PURE__ */ n.jsx(w, { size: 24 })
    ] }),
    /* @__PURE__ */ n.jsxs(N, { children: [
      "Start by adding a file at",
      " ",
      /* @__PURE__ */ n.jsxs("code", { children: [
        "{PROJECT_ROOT}",
        "/",
        r["*"],
        ".mdx"
      ] }),
      " ",
      "and add some content to make this error go away."
    ] }),
    /* @__PURE__ */ n.jsx("p", { children: "It seems that the page you are looking for does not exist or may have been moved. Please check the URL for any typos or use the navigation menu to find the correct page." }),
    /* @__PURE__ */ n.jsx(O, { to: "/", children: "Go back home" })
  ] });
}, I = D(
  ({ code: r, children: a, ...s }) => {
    const { syntaxHighlighting: i } = U().options;
    z(i?.highlighter, "Highlighter not found");
    const u = V(
      i.highlighter,
      r ?? a,
      s.language,
      i.themes
    );
    return /* @__PURE__ */ n.jsx(q, { ...s, children: u });
  }
);
I.displayName = "SyntaxHighlight";
function G({ error: r }) {
  const a = r instanceof Error ? r.message : "Something went wrong", s = r instanceof C ? r.developerHint : void 0, i = r instanceof C ? r.title : "Something went wrong", u = r instanceof Error ? r.stack : void 0, l = r instanceof Error ? r.cause : void 0, f = l instanceof Error ? String(l.stack) : u;
  return /* @__PURE__ */ n.jsxs(
    "div",
    {
      className: Z(
        v,
        "grid grid-cols-1 !max-w-none pt-[--padding-content-top]"
      ),
      children: [
        /* @__PURE__ */ n.jsx(y, { level: 1, children: i }),
        "Error: ",
        a,
        s && /* @__PURE__ */ n.jsx(N, { className: "mb-4", children: s }),
        f && /* @__PURE__ */ n.jsx("div", { children: /* @__PURE__ */ n.jsx(
          I,
          {
            className: "max-h-[400px] border mt-2",
            language: "js",
            code: f
          }
        ) })
      ]
    }
  );
}
function me() {
  const r = M();
  return L(r) && r.status === 404 ? /* @__PURE__ */ n.jsx(j, {}) : /* @__PURE__ */ n.jsx(G, { error: r });
}
var S = { exports: {} }, t = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var x;
function X() {
  if (x) return t;
  x = 1;
  var r = Symbol.for("react.transitional.element"), a = Symbol.for("react.portal"), s = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), u = Symbol.for("react.profiler"), l = Symbol.for("react.consumer"), f = Symbol.for("react.context"), m = Symbol.for("react.forward_ref"), E = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), _ = Symbol.for("react.memo"), T = Symbol.for("react.lazy"), R = Symbol.for("react.view_transition"), h = Symbol.for("react.client.reference");
  function c(e) {
    if (typeof e == "object" && e !== null) {
      var p = e.$$typeof;
      switch (p) {
        case r:
          switch (e = e.type, e) {
            case s:
            case u:
            case i:
            case E:
            case d:
            case R:
              return e;
            default:
              switch (e = e && e.$$typeof, e) {
                case f:
                case m:
                case T:
                case _:
                  return e;
                case l:
                  return e;
                default:
                  return p;
              }
          }
        case a:
          return p;
      }
    }
  }
  return t.ContextConsumer = l, t.ContextProvider = f, t.Element = r, t.ForwardRef = m, t.Fragment = s, t.Lazy = T, t.Memo = _, t.Portal = a, t.Profiler = u, t.StrictMode = i, t.Suspense = E, t.SuspenseList = d, t.isContextConsumer = function(e) {
    return c(e) === l;
  }, t.isContextProvider = function(e) {
    return c(e) === f;
  }, t.isElement = function(e) {
    return typeof e == "object" && e !== null && e.$$typeof === r;
  }, t.isForwardRef = function(e) {
    return c(e) === m;
  }, t.isFragment = function(e) {
    return c(e) === s;
  }, t.isLazy = function(e) {
    return c(e) === T;
  }, t.isMemo = function(e) {
    return c(e) === _;
  }, t.isPortal = function(e) {
    return c(e) === a;
  }, t.isProfiler = function(e) {
    return c(e) === u;
  }, t.isStrictMode = function(e) {
    return c(e) === i;
  }, t.isSuspense = function(e) {
    return c(e) === E;
  }, t.isSuspenseList = function(e) {
    return c(e) === d;
  }, t.isValidElementType = function(e) {
    return typeof e == "string" || typeof e == "function" || e === s || e === u || e === i || e === E || e === d || typeof e == "object" && e !== null && (e.$$typeof === T || e.$$typeof === _ || e.$$typeof === f || e.$$typeof === l || e.$$typeof === m || e.$$typeof === h || e.getModuleId !== void 0);
  }, t.typeOf = c, t;
}
var o = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var g;
function B() {
  return g || (g = 1, process.env.NODE_ENV !== "production" && function() {
    function r(e) {
      if (typeof e == "object" && e !== null) {
        var p = e.$$typeof;
        switch (p) {
          case a:
            switch (e = e.type, e) {
              case i:
              case l:
              case u:
              case d:
              case _:
              case h:
                return e;
              default:
                switch (e = e && e.$$typeof, e) {
                  case m:
                  case E:
                  case R:
                  case T:
                    return e;
                  case f:
                    return e;
                  default:
                    return p;
                }
            }
          case s:
            return p;
        }
      }
    }
    var a = Symbol.for("react.transitional.element"), s = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), u = Symbol.for("react.strict_mode"), l = Symbol.for("react.profiler"), f = Symbol.for("react.consumer"), m = Symbol.for("react.context"), E = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), _ = Symbol.for("react.suspense_list"), T = Symbol.for("react.memo"), R = Symbol.for("react.lazy"), h = Symbol.for("react.view_transition"), c = Symbol.for("react.client.reference");
    o.ContextConsumer = f, o.ContextProvider = m, o.Element = a, o.ForwardRef = E, o.Fragment = i, o.Lazy = R, o.Memo = T, o.Portal = s, o.Profiler = l, o.StrictMode = u, o.Suspense = d, o.SuspenseList = _, o.isContextConsumer = function(e) {
      return r(e) === f;
    }, o.isContextProvider = function(e) {
      return r(e) === m;
    }, o.isElement = function(e) {
      return typeof e == "object" && e !== null && e.$$typeof === a;
    }, o.isForwardRef = function(e) {
      return r(e) === E;
    }, o.isFragment = function(e) {
      return r(e) === i;
    }, o.isLazy = function(e) {
      return r(e) === R;
    }, o.isMemo = function(e) {
      return r(e) === T;
    }, o.isPortal = function(e) {
      return r(e) === s;
    }, o.isProfiler = function(e) {
      return r(e) === l;
    }, o.isStrictMode = function(e) {
      return r(e) === u;
    }, o.isSuspense = function(e) {
      return r(e) === d;
    }, o.isSuspenseList = function(e) {
      return r(e) === _;
    }, o.isValidElementType = function(e) {
      return typeof e == "string" || typeof e == "function" || e === i || e === l || e === u || e === d || e === _ || typeof e == "object" && e !== null && (e.$$typeof === R || e.$$typeof === T || e.$$typeof === m || e.$$typeof === f || e.$$typeof === E || e.$$typeof === c || e.getModuleId !== void 0);
    }, o.typeOf = r;
  }()), o;
}
var P;
function J() {
  return P || (P = 1, process.env.NODE_ENV === "production" ? S.exports = /* @__PURE__ */ X() : S.exports = /* @__PURE__ */ B()), S.exports;
}
var K = /* @__PURE__ */ J();
const Y = A.createContext({}), Ee = ({
  slotlets: r,
  children: a
}) => /* @__PURE__ */ n.jsx(Y.Provider, { value: r, children: a }), de = ({ name: r }) => {
  const s = H(Y)?.[r], i = W();
  return K.isValidElementType(s) ? A.createElement(s, i) : s;
};
export {
  N as D,
  G as E,
  me as R,
  de as S,
  Ee as a
};
//# sourceMappingURL=SlotletProvider-CTgIBRWg.js.map
